export default {
	TYPE: 'type',
	PLACE: 'place',
	PRODUCT_TYPE: 'product_type',
	PRODUCT_PLACE: 'product_place',
	CONSULT_TYPE: 'consult_type',
	CONSULT_PLACE: 'consult_place',
};
